import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { SplashScreen as SplashScreenComponent } from '../components/splash';
export function SplashScreen() {
  const navigate = useNavigate();
  const handleGetStarted = () => {
    navigate('/home');
  };
  return <SplashScreenComponent onGetStarted={handleGetStarted} data-id="lamunin-splash" />;
}